import { useState, useEffect } from 'react';
import ExpenseService from './ExpenseService';

const useExpense = () => {
  const [expenseOptions, setExpenseOptions] = useState([])
  const [expenses, setExpenses] = useState([])
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);

  const addExpenseOptions = async (newOption) => {
    let result = true
    setIsLoading(true);
    try {
        await ExpenseService.addExpenseOptions(newOption);
        await getExpenseOptions()
        result = true
    } catch (err) {
        result = false
        console.log(err.response.data.message || 'An error occurred.');
        setError(err.response.data.message);
    } finally {
      setIsLoading(false);
    }
    return result
  };

  const saveExpenseRecord = async (formData) => {
    let result = true
    setIsLoading(true);
    try {
      const newRecord = await ExpenseService.saveExpenseRecord(formData);
      getExpenseRecords()
        result = true
    } catch (err) {
        result = false
        console.log(err.response.data.message || 'An error occurred.');
        setError(err.response.data.message);
    } finally {
      setIsLoading(false);
    }
    return result
  };

  const getExpenseOptions = async () => {
    setIsLoading(true);
    try {
      const response = await ExpenseService.getExpenseOptions();
      console.log(response)
      setExpenseOptions(response.data);
      setError(null);
    } catch (err) {
        setError(err);
    } finally {
        setIsLoading(false);
    }
  };

  const editExpenseOption = async (id, updatedData) => {
    setIsLoading(true);
    try {
        await ExpenseService.editExpenseOption(id, updatedData);
        await getExpenseOptions();
    } catch (err) {
        setError(err);
    } finally {
        setIsLoading(false);
    }
};

  const deleteExpenseOption = async (id) => {
    let result = true
    setIsLoading(true);
    try {
        await ExpenseService.deleteExpenseOption(id);
        await getExpenseOptions();
    } catch (err) {
        console.log(err)
        setError(err);
        result = false
    } finally {
        setIsLoading(false);
    }
    return result
};

const getExpenseRecords = async () => {
  setIsLoading(true);
  try {
    const response = await ExpenseService.getExpenseRecords();
    console.log(response)
    setExpenses(response.data);
    setError(null);
  } catch (err) {
      setError(err);
  } finally {
      setIsLoading(false);
  }
};

const deleteExpense = async (id) => {
  let result = true
  setIsLoading(true);
  try {
      await ExpenseService.deleteExpense(id);
      setExpenses(currentExpenses => currentExpenses.filter(expense => expense.id !== id));
  } catch (err) {
      console.log(err)
      setError(err);
      result = false
  } finally {
      setIsLoading(false);
  }
  return result
};


  return { 
    error,
    expenseOptions,
    expenses,
    addExpenseOptions,
    getExpenseOptions,
    editExpenseOption,
    deleteExpenseOption,
    saveExpenseRecord,
    getExpenseRecords,
    deleteExpense
  };
}

export default useExpense;
